<template>
  <v-container fluid class="gl-report-list mt-3">
        <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/gl-post/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                GL Post
              </v-btn>
              <v-btn to="/bankaccount/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Accounts
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              loading-text="Loading... Please wait"
              class="gl-reports-table"
              show-select
              single-select
              item-key="_id"
              sort-by="report"
              :footer-props="footer"
              :headers="header_reports"
              :items="data_reports"

              :items-per-page="itemPerPage">
              <template v-slot:item.reportname="{ item }">
                <p class="two-line"><a class="primaryConst--text" v-on:click="viewItem(item)">{{ item.reportname }}</a></p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-file-find-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'GLLedgerList',
  data() {
    return {
      data_reports: [
        {reportname:'Income Statement', name: 'GLReportIS'},
        {reportname:'Balance Sheet', name: 'GLReportBS'},
        {reportname:'General Ledger', name: 'GLReportGL'},
        {reportname:'Trial Balance', name: 'GLReportTB'},
      ],
      header_reports: [
        { text: 'Report Name', value: 'reportname' },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  methods: {
    viewItem(item) {
      this.$router.push({ name: item.name })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
